import React from 'react';
import { Button, Typography } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import AuthLayout from '../../layouts/AuthLayout';

const { Title, Text } = Typography;

export default function PaymentCancelPage() {
  return (
    <AuthLayout>
      <div style={{ textAlign: 'center', padding: '48px 24px' }}>
        <CloseCircleOutlined style={{ fontSize: 64, color: '#ff4d4f', marginBottom: 24 }} />
        <Title level={2} style={{ color: '#fff', marginBottom: 8 }}>
          Pago cancelado
        </Title>
        <Text style={{ color: 'rgba(255,255,255,0.65)', display: 'block', marginBottom: 32 }}>
          No se realizó ningún cobro. Puedes intentarlo de nuevo cuando quieras.
        </Text>
        <Button type="primary" size="large" href="https://futpremia.com/">
          Volver al portal
        </Button>
      </div>
    </AuthLayout>
  );
}
